import httpPoller from "webutils/http-poller.service";

export default ($parse) => ({
  restrict: "EA",
  link(scope, element, attrs) {
    var url = attrs.httpPoller || attrs.src || attrs.url || attrs.ngSrc;
    var options = Object.assign({ url }, scope.$eval(attrs.httpPollerOptions));
    httpPoller(options).then((response) => {
      var httpPollerOnLoad =
        attrs.httpPollerOnLoad && $parse(attrs.httpPollerOnLoad);
      if (httpPollerOnLoad) {
        httpPollerOnLoad(scope, { response });
      }
    });
  },
});
